import logo from "assets/logoCopaHorizontal.png";

export const images = {
  logo,
};
